import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: TransportState = {
  latest: [],
  active: { Meta: { Page: 0, ResultsPerPage: 20, TotalPages: 0, TotalResults: 0 }, Results: [] },
  searched: { Meta: { Page: 0, ResultsPerPage: 20, TotalPages: 0, TotalResults: 0 }, Results: [] },
  archived: { Meta: { Page: 0, ResultsPerPage: 20, TotalPages: 0, TotalResults: 0 }, Results: [] },
  importPlanning: { Meta: { Page: 0, ResultsPerPage: 20, TotalPages: 0, TotalResults: 0 }, Results: [] },
  transports: [],
  viewing_id: null,
  viewing_goods: [],
  viewing_containers: [],
};

const rootState: TransportState = initialState;

const getters: GetterTree<TransportState, RootState> = {
  latest(state: TransportState): FvgTransport[] | undefined {
    return state.latest;
  },
  active(state: TransportState): FvgTransportSearchResults | undefined {
    return state.active;
  },
  importPlanning(state: TransportState): FvgImportPlanningSearchResults | undefined {
    return state.importPlanning;
  },
  searched(state: TransportState): FvgTransportSearchResults | undefined {
    return state.searched;
  },
  viewing(state: TransportState): FvgTransport | undefined {
    return state.transports.find(transport => transport.Id === state.viewing_id);
  },
  goods(state: TransportState): FvgGood[] {
    return state.viewing_goods;
  },
  containers(state: TransportState): FvgContainer[] {
    return state.viewing_containers;
  },
};

const mutations: MutationTree<TransportState> = {
  SET_TRANSPORTS(state: TransportState, transports: FvgTransport[]) {
    // @ts-ignore
    const transportModes = this.state.lookup.transportmodes;
    state.transports = transports.map(t => {
      return {
        ...t,
        Mode: transportModes.find((mode: Lookup) => mode.Id === t.TransportMode).Description,
      };
    });
  },
  SET_LATEST(state: TransportState, transports: FvgTransport[]) {
    // @ts-ignore
    const transportModes = this.state.lookup.transportmodes;
    state.latest = transports.map(t => {
      return {
        ...t,
        Mode: transportModes.find((mode: Lookup) => mode.Id === t.TransportMode).Description,
      };
    });
  },
  SET_ACTIVE(state: TransportState, transports: FvgTransportSearchResults) {
    // @ts-ignore
    const transportModes = this.state.lookup.transportmodes;
    state.active.Meta = transports.Meta;
    const mappedTransports = transports.Results.map((t: FvgTransport) => {
      return {
        ...t,
        Mode: transportModes.find((mode: Lookup) => mode.Id === t.TransportMode).Description,
      };
    });

    // @ts-ignore
    state.active.Results = state.active.Results.concat(mappedTransports);
  },
  UPDATE_IMPORT_PLANNING(state: TransportState, importPlanning: FvgImportPlanningSearchResults) {
    state.importPlanning.Meta = importPlanning.Meta;
    state.importPlanning.Results = state.importPlanning.Results.concat(importPlanning.Results);
  },
  SET_IMPORT_PLANNING(state: TransportState, importPlanning: FvgImportPlanningSearchResults) {
    state.importPlanning.Meta = importPlanning.Meta;
    state.importPlanning.Results = importPlanning.Results;
  },
  SET_SEARCHED(state: TransportState, transports: FvgTransportSearchResults) {
    // @ts-ignore
    const transportModes = this.state.lookup.transportmodes;
    state.searched.Meta = transports.Meta;
    const mappedTransports = transports.Results.map((t: FvgTransport) => {
      const m = transportModes.find((mode: Lookup) => mode.Id === t.TransportMode);
      if (!m) {
        return { ...t };
      }
      return {
        ...t,
        Mode: m.Description,
      };
    });

    // @ts-ignore
    state.searched.Results = state.searched.Results.concat(mappedTransports);
  },
  CLEAR_SEARCHED(state: TransportState) {
    state.searched = { Meta: { Page: 0, ResultsPerPage: 20, TotalPages: 0, TotalResults: 0 }, Results: [] };
  },
  SET_VIEWING(state: TransportState, id: number) {
    state.viewing_id = id;
  },
  SET_VIEWING_GOODS(state: TransportState, goods: FvgGood[]) {
    state.viewing_goods = goods;
  },
  SET_VIEWING_CONTAINERS(state: TransportState, containers: FvgContainer[]) {
    state.viewing_containers = containers;
  },
  RESET(state: TransportState) {
    Object.assign(state, initialState);
  },
};

const actions: ActionTree<TransportState, RootState> = {
  latest({ commit }): any {
    // @ts-ignore
    return this._vm.$api
      .get('transports', { params: { limit: 4 } })
      .then((data: ApiResponseTransports) => {
        commit('SET_LATEST', data.data);
        return Promise.resolve(data.data);
      })
      .catch((e: any) => {
        return Promise.reject([e.response.data]);
      });
  },
  index({ commit }): any {
    // @ts-ignore
    return this._vm.$api
      .get(`transports`)
      .then((data: ApiResponseTransport) => {
        commit('SET_TRANSPORTS', [data.data]);
        return Promise.resolve(data.data);
      })
      .catch((e: any) => {
        return Promise.reject([e.response.data]);
      });
  },
  read({ commit }, id: number): any {
    // @ts-ignore
    return this._vm.$api
      .get(`transports/${id}`)
      .then((data: ApiResponseTransport) => {
        commit('SET_TRANSPORTS', [data.data]);
        commit('SET_VIEWING', data.data.Id);
        return Promise.resolve(data.data);
      })
      .catch((e: any) => {
        return Promise.reject([e.response.data]);
      });
  },
  readActive({ commit }, page: number): any {
    if (!page) {
      page = 1;
    }
    // @ts-ignore
    return this._vm.$api
      .get(`transports?status=active&page=${page}`)
      .then((data: ApiResponseFile) => {
        commit('SET_ACTIVE', data.data);
        return Promise.resolve(data.data);
      })
      .catch((e: any) => {
        return Promise.reject([e.response.data]);
      });
  },
  readImportPlanning({ commit }, page: number): any {
    if (!page) {
      page = 1;
    }
    // @ts-ignore
    return this._vm.$api
      .get(`transports/importplanning?page=${page}&limit=900`)
      .then((data: ApiResponseFile) => {
        commit('SET_IMPORT_PLANNING', data.data);
        return Promise.resolve(data.data);
      })
      .catch((e: any) => {
        return Promise.reject([e.response.data]);
      });
  },
  clearSearch({ commit }): any {
    commit('CLEAR_SEARCHED');
  },
  search({ commit }, payload: any): any {
    payload.Limit = 900;
    // @ts-ignore
    return this._vm.$api
      .post(`transports/search`, payload)
      .then((data: ApiResponseTransport) => {
        commit('SET_SEARCHED', data.data);
        return Promise.resolve(data.data);
      })
      .catch((e: any) => {
        if (e.response) {
          return Promise.reject([e.response.data]);
        }
      });
  },
  readGoods({ commit }, id: number): any {
    // @ts-ignore
    return this._vm.$api
      .get(`transports/${id}/goods`)
      .then((data: ApiResponseGood) => {
        commit('SET_VIEWING_GOODS', data.data);
        return Promise.resolve(data.data);
      })
      .catch((e: any) => {
        return Promise.reject([e.response.data]);
      });
  },
  readContainers({ commit }, id: number): any {
    // @ts-ignore
    return this._vm.$api
      .get(`transports/${id}/containers`)
      .then((data: ApiResponseContainer) => {
        commit('SET_VIEWING_CONTAINERS', data.data);
        return Promise.resolve(data.data);
      })
      .catch((e: any) => {
        return Promise.reject([e.response.data]);
      });
  },
  updateCarrier({ commit }, payload): any {
    const url = `transports/${payload.transId}/containers/${payload.ctrId}/releaseto/${payload.orgId}`;
    // @ts-ignore
    return this._vm.$api
      .post(url)
      .then((data: ApiResponseContainer) => {
        return Promise.resolve(data.data);
      })
      .catch((e: any) => {
        return Promise.reject([e.response.data]);
      });
  },
  updateDeliveryrequest({ commit }, payload): any {
    const url = `transports/deliveryrequest`;
    // @ts-ignore
    return this._vm.$api
      .put(url, payload)
      .then((data: ApiResponseContainer) => {
        return Promise.resolve(data.data);
      })
      .catch((e: any) => {
        return Promise.reject([e.response.data]);
      });
  },
};

export default {
  namespaced: true,
  state: rootState,
  getters,
  actions,
  mutations,
};
